import Decimal from "decimal.js";
import { ZeroAddress } from "ethers";

// Define the interface
export interface IAffiliate {
  user: string;
  revoked: boolean;
  profitPercent: number; // 0 - 100
  tokensSold: Decimal;
  usdtProfit: Decimal;
  nativeProfit: Decimal;
  usdtWithdrawn: Decimal;
  nativeWithdrawn: Decimal;
  code: string;
}

// Define the class
export class Affiliate implements IAffiliate {
  user: string;
  revoked: boolean;
  profitPercent: number;
  tokensSold: Decimal;
  usdtProfit: Decimal;
  nativeProfit: Decimal;
  usdtWithdrawn: Decimal;
  nativeWithdrawn: Decimal;
  code: string;

  constructor(data: IAffiliate) {
    this.user = data.user;
    this.revoked = data.revoked;
    this.profitPercent = data.profitPercent;
    this.tokensSold = new Decimal(data.tokensSold);
    this.usdtProfit = new Decimal(data.usdtProfit);
    this.nativeProfit = new Decimal(data.nativeProfit);
    this.usdtWithdrawn = new Decimal(data.usdtWithdrawn);
    this.nativeWithdrawn = new Decimal(data.nativeWithdrawn);
    this.code = data.code;
  }

  isNonExistant() {
    return this.user === ZeroAddress;
  }
  // Convert an ethers.js response (array format) into an Affiliate instance
  static fromEthersResponse(response: any[]): Affiliate {
    return new Affiliate({
      user: response[0],
      revoked: response[1],
      profitPercent: Number(response[2]),
      tokensSold: new Decimal(response[3].toString()),
      usdtProfit: new Decimal(response[4].toString()),
      nativeProfit: new Decimal(response[5].toString()),
      usdtWithdrawn: new Decimal(response[6].toString()),
      nativeWithdrawn: new Decimal(response[7].toString()),
      code: response[8],
    });
  }

  // Get remaining profit
  getRemainingProfit(): { usdt: Decimal; native: Decimal } {
    return {
      usdt: this.usdtProfit.minus(this.usdtWithdrawn),
      native: this.nativeProfit.minus(this.nativeWithdrawn),
    };
  }
  toJSON(): Record<string, any> {
    return {
      user: this.user,
      revoked: this.revoked,
      profitPercent: this.profitPercent,
      tokensSold: this.tokensSold.toString(),
      usdtProfit: this.usdtProfit.toString(),
      nativeProfit: this.nativeProfit.toString(),
      usdtWithdrawn: this.usdtWithdrawn.toString(),
      nativeWithdrawn: this.nativeWithdrawn.toString(),
      code: this.code,
    };
  }

  static fromJSON(json: Record<string, any>): Affiliate {
    return new Affiliate({
      user: json.user,
      revoked: json.revoked,
      profitPercent: json.profitPercent,
      tokensSold: new Decimal(json.tokensSold),
      usdtProfit: new Decimal(json.usdtProfit),
      nativeProfit: new Decimal(json.nativeProfit),
      usdtWithdrawn: new Decimal(json.usdtWithdrawn),
      nativeWithdrawn: new Decimal(json.nativeWithdrawn),
      code: json.code,
    });
  }
}
